module.exports = __webpack_public_path__ + "static/media/hero_img_ai.7ffc899b.png";